import React from 'react';
import PropTypes from 'prop-types';
import SelectionList from '../../SelectionList';
import SectionHeader from '../../SectionHeader';
import { getScoreLabel } from '../../../../../../utils/shared/trcUtils';

const Retell = ({ retellScore, currentRetellInfo }) => {
    const { complete, actualResult, maxResult } = retellScore;
    const { content, name } = currentRetellInfo;
    return complete ? (
        <section className="section-block">
            <SectionHeader titles={[name, getScoreLabel(actualResult, maxResult)]} />
            <SelectionList list={content} resultScore={actualResult} />
        </section>
    ) : (
        <h4>{name} has not been administered</h4>
    );
};

Retell.defaultProps = {
    currentRetellInfo: {},
    retellScore: {},
};

Retell.propTypes = {
    currentRetellInfo: PropTypes.object,
    retellScore: PropTypes.object,
};

export default Retell;
